import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Center,
  HStack,
  Heading,
  Spacer,
  Spinner,
  Text,
  VStack,
} from "native-base";
import { Helmet } from "react-helmet-async";
import { StateContext, StatusContext } from "../../contexts";
import API from "../../api";
import colors from "../../constants/colors";
import Tour from "../../components/tour";
import { RiFolderWarningLine } from "react-icons/ri";

function TrypsPage() {
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [searchParams] = useSearchParams();
  const [tours, setTours] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (searchParams.get("tour")) {
      window.alert(
        `Tu viaje ha sido creado con el folio #${searchParams.get("tour")}.`,
      );
    }
  }, [searchParams]);

  const getTours = useCallback(
    async (signal) => {
      try {
        setIsLoading(true);
        const {
          data: {
            data: _tours,
            meta: { total: _total },
          },
        } = await API(state.jwt).get("/tours/user", signal ? { signal } : {});
        setTotal(_total);
        setTours(_tours);
      } catch (error) {
        status.updateErrorMessage(error);
      }
      setIsLoading(false);
    },
    [state.jwt, status],
  );

  useEffect(() => {
    const controller = new AbortController();
    getTours(controller.signal);
    return () => {
      controller.abort();
    };
  }, [getTours]);

  return (
    <VStack paddingX={5}>
      <Helmet>
        <title>Mis viajes</title>
      </Helmet>
      <HStack paddingTop={8}>
        <Heading color={colors.secondary} fontSize="2xl">
          Mis Viajes
        </Heading>
      </HStack>
      <Text fontSize="sm" textAlign="right">
        Se han encontrado {total} resultado{total !== 1 && "s"}
      </Text>
      <Spacer height={5} />
      {isLoading ? (
        <Center height={300}>
          <Spinner size="lg" color={colors.primary} />
        </Center>
      ) : tours.length ? (
        <HStack flexWrap="wrap">
          {tours.map((tour, index) => (
            <Tour key={String(tour.id)} tour={tour} index={index} role="user" />
          ))}
        </HStack>
      ) : (
        <Center height={300}>
          <RiFolderWarningLine color={colors.secondary} fontSize={100} />
          <Text color={colors.secondary}>No hay información disponible</Text>
        </Center>
      )}
    </VStack>
  );
}

export default TrypsPage;
